import { API_URL } from './../../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showWarningMessage,
    showErrorMessage,
} from './../../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    extractDataFromObject,
    showWarningMessage,
    showErrorMessage,
   API_URL,
};


//export const SERVICE_CODE = `${API_URL}/master-service-code`;// ?page[size]=10
export const SERVICE_CODE = `${API_URL}/api/MasterServiceCodes/GetMasterServiceCodes`;
export const SAVE_SERVICE_CODE = `${API_URL}/api/MasterServiceCodes/SaveMasterServiceCode`;
export const DELETE_SERVICE_CODE = `${API_URL}/api/MasterServiceCodes/DeleteMasterServiceCodes`; 
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_MASTERSERVICECODE_BYID = `${API_URL}/api/MasterServiceCodes/GetMasterServiceCodeById`;

export const ServiceCodeActionTypes = {
  get_master_data: createRequestActionTypes('GET_MASTER_DATA'),
  get_service_codes: createRequestActionTypes('GET_SERVICECODE'),
  get_ServiceCode_BySeachText: createRequestActionTypes('GET_SERVICECODE_BYSEARCHTEXT'),
  post_service_code: createRequestActionTypes('POST_SERVICECODE'),
  patch_service_code: createRequestActionTypes('PATCH_SERVICECODE'),
  delete_service_code: createRequestActionTypes('DELETE_SERVICECODE'),
  get_masterservicecode_by_Id: createRequestActionTypes('GET_MASTERSERVICECODE_BYID'),
};

export const MODULE = 'MASTER_SERVICECODE';



// WEBPACK FOOTER //
// ./src/modules/Masters/components/serviceCode/constants/ApiConstants.js